module.exports = __webpack_public_path__ + "static/media/line-chart-line.028dc962.svg";